var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 3.33337H14.9997C15.4417 3.33337 15.8656 3.50897 16.1782 3.82153C16.4907 4.13409 16.6663 4.55801 16.6663 5.00004V16.6667C16.6663 17.1087 16.4907 17.5327 16.1782 17.8452C15.8656 18.1578 15.4417 18.3334 14.9997 18.3334H4.99967C4.55765 18.3334 4.13372 18.1578 3.82116 17.8452C3.5086 17.5327 3.33301 17.1087 3.33301 16.6667V5.00004C3.33301 4.55801 3.5086 4.13409 3.82116 3.82153C4.13372 3.50897 4.55765 3.33337 4.99967 3.33337H6.66634",
    stroke: "#6D6D6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 1.66663H7.50033C7.04009 1.66663 6.66699 2.03972 6.66699 2.49996V4.16663C6.66699 4.62686 7.04009 4.99996 7.50033 4.99996H12.5003C12.9606 4.99996 13.3337 4.62686 13.3337 4.16663V2.49996C13.3337 2.03972 12.9606 1.66663 12.5003 1.66663Z",
    stroke: "#56585A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.76689e569934a398ed4c9fe43172d681.svg";
export { ForwardRef as ReactComponent };